module.exports = __webpack_public_path__ + "img/IMG_2479.bf168243.jpg";